import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-8 pb-12 md:pt-20 md:pb-32 px-4 md:px-6 overflow-hidden" data-id="element-145">
      {/* Base background gradient: deep navy */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F1D32] via-[#0A1628] to-[#0A1628] -z-20" data-id="element-146" />

      {/* Primary light beam — blue glow from top center */}
      <div className="absolute -z-10 pointer-events-none" style={{
      top: '-10%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '60vw',
      height: '110%',
      background: 'radial-gradient(ellipse 50% 80% at 50% 0%, rgba(59,130,246,0.3) 0%, rgba(30,58,95,0.4) 30%, rgba(10,22,40,0.1) 65%, transparent 100%)',
      filter: 'blur(2px)'
    }} data-id="element-147" />

      {/* Secondary wide ambient glow */}
      <div className="absolute -z-10 pointer-events-none" style={{
      top: '-5%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100vw',
      height: '80%',
      background: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(59,130,246,0.15) 0%, rgba(30,58,95,0.08) 50%, transparent 100%)'
    }} data-id="element-148" />

      {/* Bright core — subtle white/blue glow at top */}
      <div className="absolute -z-10 pointer-events-none" style={{
      top: '-20px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '40vw',
      height: '200px',
      background: 'radial-gradient(ellipse 60% 100% at 50% 0%, rgba(255,255,255,0.12) 0%, rgba(59,130,246,0.15) 40%, transparent 100%)',
      filter: 'blur(8px)'
    }} data-id="element-149" />

      {/* Subtle light ray */}
      <div className="absolute -z-10 pointer-events-none opacity-20" style={{
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '2px',
      height: '70%',
      background: 'linear-gradient(to bottom, rgba(255,255,255,0.5), transparent)',
      boxShadow: '0 0 60px 30px rgba(59,130,246,0.3)'
    }} data-id="element-150" />

      {/* Content */}
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-151">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-20" data-id="element-152">
          <div className="flex-1 text-center md:text-left z-10" data-id="element-153">
            <FadeIn data-id="element-154">
              <span className="inline-block text-gold font-medium tracking-wider uppercase text-xs md:text-sm mb-3 md:mb-6" data-id="element-155">
                Maternidad en Equilibrio
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-156">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif leading-tight mb-4 md:mb-6 text-balance text-white" data-id="element-157">
                Guía del Sueño del Bebé <br className="hidden md:block" data-id="element-158" />
                <span className="text-gold italic text-2xl md:text-4xl lg:text-5xl" data-id="element-159">
                  (0 a 3 Años)
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-160">
              <p className="text-base md:text-xl text-white/70 leading-relaxed mb-6 md:mb-8 max-w-xl mx-auto md:mx-0" data-id="element-161">
                Ventanas de sueño, rutinas efectivas y cómo reducir despertares
                nocturnos (paso a paso)
              </p>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-xs md:max-w-none relative" data-id="element-162">
            <FadeIn delay={0.3} direction="left" data-id="element-163">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-square" data-id="element-164">
                <div className="absolute inset-0 bg-gradient-to-b from-navy/20 to-transparent mix-blend-overlay z-10" data-id="element-165" />
                <img src="https://cdn.magicpatterns.com/uploads/mARtE8dSbeoQ4asGp4MU3z/heylloyd-image-1772909402894.png" alt="Mamá sosteniendo a su bebé dormido con una tablet mostrando la guía" className="object-cover w-full h-full" loading="eager" decoding="async" data-id="element-166" />
              </div>
              <div className="absolute -inset-4 bg-blue-500/20 blur-3xl -z-10 rounded-full opacity-60" data-id="element-167" />
            </FadeIn>
          </div>
        </div>

        <FadeIn delay={0.4} className="flex justify-center mt-8 md:mt-12" data-id="element-168">
          <Button className="w-full md:w-auto" data-id="element-169">Empezar hoy</Button>
        </FadeIn>
      </div>

      {/* Bottom fade to navy */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-b from-transparent to-[#0A1628] -z-10 pointer-events-none" data-id="element-170" />
    </section>;
}